import * as React from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText, Toolbar, Divider } from '@mui/material';
import { LocalOffer, Inventory, Category, Article, Discount } from '@mui/icons-material/';

// import { getAuth, signOut } from 'firebase/auth';
import { useLocation, Link } from 'react-router-dom';
import { routeName } from '../../routes/paths';

function AccountMenu() {
  const location = useLocation();

  return (
    <div>
      <Toolbar />
      <Divider />
      <List>
        <ListItemButton component={Link} to={routeName.BRANDS} selected={location.pathname === routeName.BRANDS}>
          <ListItemIcon>
            <LocalOffer />
          </ListItemIcon>
          <ListItemText primary='Brands' />
        </ListItemButton>
        <ListItemButton component={Link} to={routeName.PRODUCTS} selected={location.pathname === routeName.PRODUCTS}>
          <ListItemIcon>
            <Inventory />
          </ListItemIcon>
          <ListItemText primary='Products' />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to={routeName.CATEGORIES}
          selected={location.pathname === routeName.CATEGORIES}>
          <ListItemIcon>
            <Category />
          </ListItemIcon>
          <ListItemText primary='Categories' />
        </ListItemButton>
        <ListItemButton component={Link} to={routeName.TAGS} selected={location.pathname === routeName.TAGS}>
          <ListItemIcon>
            <LocalOffer />
          </ListItemIcon>
          <ListItemText primary='Tags' />
        </ListItemButton>

        <Divider />
        {/* <ListItemButton component={Link} to={routeName.USERS} selected={location.pathname === routeName.USERS}>
          <ListItemIcon>
            <People />
          </ListItemIcon>
          <ListItemText primary='Users' />
        </ListItemButton> */}
        <ListItemButton component={Link} to={routeName.BLOGS} selected={location.pathname === routeName.BLOGS}>
          <ListItemIcon>
            <Article />
          </ListItemIcon>
          <ListItemText primary='Blogs' />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to={routeName.PROMOTIONS}
          selected={location.pathname === routeName.PROMOTIONS}>
          <ListItemIcon>
            <Discount />
          </ListItemIcon>
          <ListItemText primary='Promotions' />
        </ListItemButton>

        {/* <ListItemButton
          onClick={() => navigate(routeName.EDITUSER)}
          selected={location.pathname === routeName.EDITUSER}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary='Edit User' />
        </ListItemButton>
        <ListItemButton
          onClick={() => navigate(routeName.EDITPORT)}
          selected={location.pathname === routeName.EDITPORT}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary='Edit Port' />
        </ListItemButton> */}
      </List>
      <Divider />

      {/* <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List> */}
    </div>
  );
}

export default AccountMenu;
